export const TEAM_COLORS = [
  {
    label: "White",
    value: "white",
  },
  {
    label: "Red",
    value: "red",
  },
  {
    label: "Orange",
    value: "orange",
  },
  {
    label: "Pink",
    value: "pink",
  },
  {
    label: "Green",
    value: "green",
  },
  {
    label: "Yellow",
    value: "yellow",
  },
  {
    label: "Blue",
    value: "blue",
  },
  {
    label: "Purple",
    value: "purple",
  },
  {
    label: "Deep Blue",
    value: "deep_blue",
  },
  {
    label: "Brown",
    value: "brown",
  },
  {
    label: "Black",
    value: "black",
  },
];

// Color mapping utility for converting color values to CSS-compatible colors
export const getTeamColorValue = (colorValue) => {
  if (!colorValue) return null;
  
  // Map specific color values to their CSS equivalents
  const colorMap = {
    deep_blue: "#19295e",
    // Add more mappings as needed
  };
  
  return colorMap[colorValue] || colorValue;
};
